"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsService = void 0;
const core_1 = require("@apollo/client/core");
const common_1 = require("../common");
const classes_1 = require("./classes");
const native_currencies_1 = require("./classes/native-currencies");
class AssetsService extends common_1.Service {
    async getTokenLists() {
        const { apiService } = this.services;
        const { result } = await apiService.query(core_1.gql `
        query($chainId: Int) {
          result: tokenLists(chainId: $chainId) {
            items {
              name
              endpoint
              isDefault
              createdAt
              updatedAt
            }
          }
        }
      `, {
            models: {
                result: classes_1.TokenLists,
            },
        });
        return result.items;
    }
    async getTokenListTokens(name = null) {
        const { apiService } = this.services;
        const { result } = await apiService.query(core_1.gql `
        query($chainId: Int, $name: String) {
          result: tokenList(chainId: $chainId, name: $name) {
            tokens {
              address
              name
              symbol
              decimals
              logoURI
              chainId
            }
          }
        }
      `, {
            variables: {
                name,
            },
            models: {
                result: classes_1.TokenList,
            },
            fetchPolicy: 'cache-first',
        });
        return result ? result.tokens : null;
    }
    async getNativeCurrencies() {
        const { apiService } = this.services;
        const { result } = await apiService.query(core_1.gql `
        query {
          result: nativeCurrencies {
            items {
              name
              symbol
              decimals
              logoURI
              chainId
            }
          }
        }
      `, {
            models: {
                result: native_currencies_1.NativeCurrencies,
            },
        });
        return result.items;
    }
    async getAccountTokenListTokens(name = null) {
        const { apiService, accountService } = this.services;
        const account = accountService.accountAddress;
        const { result } = await apiService.query(core_1.gql `
        query($chainId: Int, $account: String!, $name: String) {
          result: accountTokenList(chainId: $chainId, account: $account, name: $name) {
            tokens {
              address
              name
              symbol
              decimals
              logoURI
              chainId
            }
          }
        }
      `, {
            variables: {
                account,
                name,
            },
            models: {
                result: classes_1.TokenList,
            },
        });
        return result ? result.tokens : null;
    }
    async isTokenOnTokenList(token, name = null) {
        const { apiService } = this.services;
        const { result } = await apiService.query(core_1.gql `
        query($chainId: Int, $token: String!, $name: String) {
          result: isTokenOnTokenList(chainId: $chainId, token: $token, name: $name)
        }
      `, {
            variables: {
                token,
                name,
            },
        });
        return result;
    }
}
exports.AssetsService = AssetsService;
